











//
// WARNING
// This file is auto-generated by Commands.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Commands.tst.
//

import { Command } from "@signature/crs-client";
import { endpoint, CommandResult } from '@/modules/crs/crs';


    

    @Command('Automelec.Model-Automelec.Model.Commands.Dashboard.UpdateDashboardCommand')
    
    export class UpdateDashboardCommand {
        constructor( dashboardId: number, name: string, config: UpdateDashboardCommand.ExtraneousTypes.ConfigModel[] ) {
            
                this.dashboardId = dashboardId;
            
                this.name = name;
            
                this.config = config;
            
        }

        
            public dashboardId: number;
        
            public name: string;
        
            public config: UpdateDashboardCommand.ExtraneousTypes.ConfigModel[];
        
    }

    export interface IUpdateDashboardCommand {
        
            dashboardId: number;
        
            name: string;
        
            config: UpdateDashboardCommand.ExtraneousTypes.ConfigModel[];
        
    }

    export async function updateDashboard( command: UpdateDashboardCommand ): Promise<CommandResult<number>>
    export async function updateDashboard( { dashboardId, name, config }: IUpdateDashboardCommand ): Promise<CommandResult<number>>
    export async function updateDashboard( model: any ): Promise<CommandResult<number>> {
        if(model == null) throw new Error("Command cannot be null.");

        var result: CommandResult<number>;

        if(model instanceof UpdateDashboardCommand) {
            result = await endpoint.send<CommandResult<number>>(model);
        }
        else {
            result = await endpoint.send<CommandResult<number>>( new UpdateDashboardCommand( model['dashboardId'], model['name'], model['config'] ) );
        }

        return result;
    }

    /**
    * Extraneous types
    */
    export namespace UpdateDashboardCommand.ExtraneousTypes {
        
            export class ConfigModel {
                
                    
                    public productionSiteId: number;
                
                    
                    public sensorId: number;
                
            }
        

        
    }

